export default __webpack_public_path__ + "static/media/akustikdecken3.804590de.jpg";